// extracted by mini-css-extract-plugin
module.exports = {"content":"Questions_content__1pLMV","title":"Questions_title__lwUav","block":"Questions_block__oHENx","collapseButton":"Questions_collapseButton__3MKM-"};